/* ============================================================
   FLOWZA — Build-your-own grip-sock bundle (loose quantity).
   No fixed pack size: add any 2+ pairs of any socks. The bundle
   discount grows with quantity (data-ladder "qty:amountOff") and is
   applied automatically at checkout. Everything reads from the DOM.
   ============================================================ */
(function () {
  "use strict";

  // Cart endpoints under the locale root ("/ar/cart.js") answer with
  // translated titles and variant names; plain "/cart.js" is always English.
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var root = document.getElementById("builder");
  if (!root) return;

  // UI strings from snippets/fz-strings.liquid; the English here is the
  // fallback for a key that is missing.
  var fzT = window.fzT || {};
  function fillIn(s, o) { s = String(s); for (var x in o) s = s.split("[" + x + "]").join(o[x]); return s; }
  function tr(k, en, o) { return fillIn(fzT[k] || en, o); }
  function trn(k, n, one, other, o) {
    var f = fzT[k];
    return fillIn(f && window.fzPlural ? window.fzPlural(f, n) : fillIn(n === 1 ? one : other, { count: n }), o);
  }

  var fmt = (root.getAttribute("data-money") || "AED {{amount}}").replace(/<[^>]*>/g, "").trim();
  function money(cents) {
    // Two decimals, matching Liquid's `| money`.
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt
      .replace("{{amount}}", amount)
      .replace("{{amount_with_comma_separator}}", amount)
      .replace("{{amount_no_decimals}}", Math.round(cents / 100))
      .replace("{{amount_no_decimals_with_comma_separator}}", Math.round(cents / 100));
  }

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  // Discount ladder: [{qty, off(cents)}], sorted ascending. The highest tier
  // whose qty <= picked applies. Last tier is the "or more" ceiling.
  var LADDER = (root.getAttribute("data-ladder") || "2:8,3:28,4:40,5:56")
    .split(",")
    .map(function (s) { var p = s.split(":"); return { qty: parseInt(p[0], 10), off: Math.round(parseFloat(p[1]) * 100) }; })
    .filter(function (t) { return t.qty > 0; })
    .sort(function (a, b) { return a.qty - b.qty; });
  var MIN = parseInt(root.getAttribute("data-min"), 10) || (LADDER[0] ? LADDER[0].qty : 2);

  // Products the ladder discount is actually scoped to (Flowza Premium
  // Collection), so pairs already sitting in the bag can be counted toward the
  // same tiers. Without this the builder demanded a fresh 2-pair minimum from a
  // customer who already had four pairs in their bag, and quoted a saving that
  // ignored them.
  var LADDER_IDS = (root.getAttribute("data-ladder-ids") || "")
    .split(",").map(function (s) { return s.trim(); }).filter(Boolean);

  var bagLadderQty = 0;   // ladder-eligible pairs already in the bag
  var bagByVariant = {};  // variant id -> qty already in the bag

  function discountFor(qty) {
    var off = 0, next = null;
    for (var i = 0; i < LADDER.length; i++) {
      if (qty >= LADDER[i].qty) off = LADDER[i].off;
      else { next = LADDER[i]; break; }
    }
    return { off: off, next: next };
  }

  var COLORS = $$(".bld-product").map(function (el) {
    return {
      name: el.getAttribute("data-color"),
      hex: el.getAttribute("data-hex") || "#2A2740",
      thumb: el.getAttribute("data-thumb") || "",
      variant: el.getAttribute("data-variant"),
      price: parseInt(el.getAttribute("data-price"), 10) || 0,
      // Missing attribute means "no product wired to this card" -- treat as
      // unlimited rather than zero, so a mis-set block never hides the card.
      stock: (function () {
        var v = parseInt(el.getAttribute("data-stock"), 10);
        return isNaN(v) ? Infinity : v;
      })(),
      el: el
    };
  });

  var picks = {};
  var byName = {};
  COLORS.forEach(function (c) { picks[c.name] = 0; byName[c.name] = c; });

  // What this card can still add: stock minus whatever is already in the bag.
  function remainingFor(c) {
    if (!c) return 0;
    var used = bagByVariant[String(c.variant)] || 0;
    return Math.max(0, c.stock - used);
  }

  function readCart(cart) {
    bagLadderQty = 0;
    bagByVariant = {};
    (cart && cart.items ? cart.items : []).forEach(function (l) {
      var vid = String(l.variant_id != null ? l.variant_id : l.id);
      bagByVariant[vid] = (bagByVariant[vid] || 0) + l.quantity;
      var scoped = LADDER_IDS.length
        ? LADDER_IDS.indexOf(String(l.product_id)) !== -1
        : (l.product_type || "").toLowerCase() === "grip socks";
      if (scoped) bagLadderQty += l.quantity;
    });
    // A pick that no longer fits (bag grew in another tab, or in the drawer)
    // gets trimmed rather than left to 422 on add.
    COLORS.forEach(function (c) {
      var r = remainingFor(c);
      if (picks[c.name] > r) picks[c.name] = r;
    });
  }

  function loadCart() {
    if (!window.fetch) return;
    fetch(cartRoot + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { readCart(cart); render(); })
      .catch(function () {});
  }

  // The drawer broadcasts after every quantity change, so the builder never
  // shows a minimum or a saving computed against a stale bag.
  document.addEventListener("fz:cart:updated", function (e) {
    readCart(e.detail);
    render();
  });

  var els = {
    name: $("#bld-name"),
    status: $("#bld-status"),
    progress: $("#bld-progress"),
    contents: $("#bld-contents"),
    sub: $("#bld-sub"),
    saveLabel: $("#bld-save-label"),
    save: $("#bld-save"),
    saveRow: $("#bld-save-row"),
    total: $("#bld-total"),
    add: $("#bld-add"),
    ctaTotal: $("#bld-cta-total"),
    ctaSave: $("#bld-cta-save")
  };
  var ladderEl = $("#bld-ladder");

  function totalPicked() { return COLORS.reduce(function (s, c) { return s + picks[c.name]; }, 0); }

  function render() {
    var qty = totalPicked();
    var effQty = qty + bagLadderQty;               // what the ladder actually sees
    var subtotal = COLORS.reduce(function (s, c) { return s + picks[c.name] * c.price; }, 0);
    var d = discountFor(effQty);
    // The bag may already have earned a tier. This panel prices the bundle being
    // built, so it shows the EXTRA saving these picks unlock, capped at their
    // own subtotal -- otherwise one pair added on top of four in the bag showed
    // a 56 AED discount against a 35 AED subtotal and a total of zero.
    var earned = discountFor(bagLadderQty).off;
    var off = Math.min(Math.max(0, d.off - earned), subtotal);
    var total = Math.max(0, subtotal - off);

    if (els.name) els.name.textContent = qty > 0 ? trn("bundle_name", qty, "[count]-pair bundle", "[count]-pair bundle") : tr("build_bundle", "Build your bundle");
    if (els.sub) els.sub.textContent = money(subtotal);
    if (els.total) els.total.textContent = money(total);
    if (els.saveRow) els.saveRow.style.display = off > 0 ? "" : "none";
    if (els.save) els.save.textContent = "− " + money(off);
    // Mobile sticky bar mirror (total always; savings only when earned)
    if (els.ctaTotal) els.ctaTotal.textContent = money(total);
    if (els.ctaSave) { if (off > 0) { els.ctaSave.hidden = false; els.ctaSave.textContent = tr("save_up_to", "Save up to [amount]", { amount: money(off) }); } else { els.ctaSave.hidden = true; } }

    // ladder highlight (which tier is active)
    if (ladderEl) {
      $$(".bld-lstep", ladderEl).forEach(function (st) {
        var q = parseInt(st.getAttribute("data-qty"), 10);
        // active = the highest tier <= what the ladder sees (picks + bag)
        var active = effQty >= q && (function () {
          for (var i = 0; i < LADDER.length; i++) { if (LADDER[i].qty > q && effQty >= LADDER[i].qty) return false; }
          return true;
        })();
        st.classList.toggle("on", active);
        st.classList.toggle("reached", effQty >= q);
      });
    }

    // status / nudge. While a 422 is being explained, leave it on screen:
    // loadCart() re-renders straight after and used to overwrite the reason
    // with the default line. The next stepper click clears it.
    if (els.status && !els.status.classList.contains("is-error")) {
      var inBag = bagLadderQty > 0
        ? " " + trn("in_bag", bagLadderQty, "You already have [count] pair in your bag.", "You already have [count] pairs in your bag.")
        : "";
      if (effQty === 0) {
        els.status.textContent = tr("status_empty", "Add any [min] or more pairs — your discount grows as you add.", { min: MIN });
        els.status.classList.remove("ready");
      } else if (effQty < MIN) {
        var short = MIN - effQty;
        els.status.textContent = trn("status_short", short, "Add [count] more pair to start saving.", "Add [count] more pairs to start saving.") + inBag;
        els.status.classList.remove("ready");
      } else if (d.next) {
        var more = d.next.qty - effQty;
        var extra = d.next.off - d.off;
        els.status.textContent = trn("status_next", more, "Add [count] more pair to save up to [amount] more.", "Add [count] more pairs to save up to [amount] more.", { amount: money(extra) }) + inBag;
        els.status.classList.add("ready");
      } else {
        els.status.textContent = tr("status_best", "Best bundle saving unlocked — save up to [amount] at checkout.", { amount: money(d.off) }) + inBag;
        els.status.classList.add("ready");
      }
    }

    // progress bar toward the top tier
    if (els.progress) {
      els.progress.innerHTML = "";
      var top = LADDER.length ? LADDER[LADDER.length - 1].qty : 5;
      var slots = Math.max(top, effQty);
      // Bag pairs fill first, in a neutral tone, so the customer can see the
      // head start they already have before their new picks stack on top.
      var filledByColor = [];
      for (var b = 0; b < bagLadderQty; b++) filledByColor.push("");
      COLORS.forEach(function (c) { for (var k = 0; k < picks[c.name]; k++) filledByColor.push(c.hex); });
      for (var i = 0; i < slots; i++) {
        var slot = document.createElement("span");
        slot.className = "bld-slot";
        if (i < filledByColor.length) {
          slot.classList.add("fill");
          if (filledByColor[i]) slot.style.background = filledByColor[i];
          else slot.classList.add("in-bag");
        }
        els.progress.appendChild(slot);
      }
    }

    // contents list
    if (els.contents) {
      els.contents.innerHTML = COLORS.filter(function (c) { return picks[c.name] > 0; }).map(function (c) {
        var img = c.thumb ? '<img class="media-img" src="' + c.thumb + '" alt="">' : "";
        return '<li class="bld-citem"><span class="bld-cthumb">' + img + '</span>' +
               '<span class="bld-cname">' + c.name + '</span>' +
               '<span class="bld-cqty">×' + picks[c.name] + "</span></li>";
      }).join("");
    }

    // Needs at least one new pick, and the ladder minimum across picks + bag.
    if (els.add) els.add.disabled = qty < 1 || effQty < MIN;

    // steppers — dec disabled at 0, inc disabled at the real stock ceiling
    COLORS.forEach(function (c) {
      var rem = remainingFor(c);
      var span = c.el.querySelector("[data-count]");
      if (span) span.textContent = picks[c.name];
      var dec = c.el.querySelector('[data-step="dec"]');
      if (dec) dec.disabled = picks[c.name] === 0;
      var inc = c.el.querySelector('[data-step="inc"]');
      if (inc) inc.disabled = picks[c.name] >= rem;
      c.el.classList.toggle("has", picks[c.name] > 0);
      c.el.classList.toggle("soldout", rem === 0);

      // Say why the + stopped, rather than letting it look broken. Counted
      // after the current picks, so the message appears at the moment the
      // stepper stops responding rather than five taps earlier.
      var note = c.el.querySelector("[data-stock-note]");
      if (note) {
        var left = rem - picks[c.name];
        var txt = "";
        if (rem === 0) txt = tr("sold_out", "Sold out");
        else if (left === 0) txt = tr("all_we_have_html", "That's all we have");
        else if (left <= 5) txt = trn("only_left", left, "Only [count] left", "Only [count] left");
        note.textContent = txt;
        note.hidden = !txt;
      }
    });
  }

  var productsWrap = $("#bld-products");
  if (productsWrap) productsWrap.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-step]");
    if (!btn) return;
    var card = btn.closest(".bld-product");
    if (!card) return;
    var name = card.getAttribute("data-color");
    // Capped at stock less whatever is already in the bag: an over-sized
    // bundle used to 422 on add and take every other colour down with it.
    if (btn.getAttribute("data-step") === "inc" && picks[name] < remainingFor(byName[name])) picks[name]++;
    if (btn.getAttribute("data-step") === "dec" && picks[name] > 0) picks[name]--;
    if (els.status) els.status.classList.remove("is-error");
    card.classList.remove("is-short");
    render();
  });

  // Add each picked grip sock as its own cart line so the store's automatic
  // quantity-based bundle discount applies at checkout.
  if (els.add) els.add.addEventListener("click", function () {
    if (totalPicked() < 1 || totalPicked() + bagLadderQty < MIN) return;
    var items = COLORS
      .filter(function (c) { return picks[c.name] > 0 && c.variant; })
      .map(function (c) { return { id: parseInt(c.variant, 10), quantity: picks[c.name] }; });
    if (!items.length) return;
    var original = els.add.textContent;
    els.add.disabled = true; els.add.textContent = tr("adding", "Adding…");
    fetch(cartRoot + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Was declaring "Added to bag ✓" on a 422 as well, so a bundle that
        // exceeded stock reported success and quietly added nothing.
        if (data && data.status) {
          // No alert(): a native dialog at the highest-intent moment on the
          // site, followed by a bag that looks empty. Shopify's description
          // names the colour that fell short ("All 3 Matcha Love are in your
          // cart."), so say it in the builder's own status line and mark
          // that card, then re-read the bag so the steppers show the new
          // ceiling instead of offering the same impossible bundle again.
          var why = data.description || tr("bundle_add_failed", "Sorry, that bundle could not be added.");
          var culprit = COLORS.filter(function (c) { return c.name && why.toLowerCase().indexOf(c.name.toLowerCase()) !== -1; })[0];
          COLORS.forEach(function (c) { c.el.classList.toggle("is-short", c === culprit); });
          if (culprit) picks[culprit.name] = 0;
          // Straight away, not when /cart.js answers: the shopper should see
          // the pick drop the moment the reason appears.
          render();
          if (els.status) {
            els.status.textContent = why + (culprit ? " " + tr("culprit_removed_html", "We've taken [name] out of this bundle -- everything else is still picked.", { name: culprit.name }) : "");
            els.status.classList.remove("ready");
            els.status.classList.add("is-error");
          }
          els.add.textContent = original; els.add.disabled = false;
          loadCart();
          return;
        }
        els.add.textContent = tr("added", "Added to bag ✓");
        // PostHog: the builder posts to /cart/add.js itself, so the drawer's
        // add_to_cart never fires for it. Counted before the picks are cleared.
        try {
          if (window.posthog && posthog.capture && !posthog.has_opted_out_capturing()) {
            posthog.capture("add_to_cart", {
              kind: "builder", via: "builder", components: items.length,
              quantity: totalPicked(), currency: "AED",
              value: COLORS.reduce(function (n, c) { return n + c.price * (picks[c.name] || 0); }, 0) / 100,
              page_type: (window.fzSurface || {}).page_type || null
            });
          }
        } catch (e) { /* analytics never breaks an add */ }
        // These pairs live in the bag now. Clearing the picks stops them being
        // counted twice — once as picks, once as bag — on the next render.
        COLORS.forEach(function (c) { picks[c.name] = 0; });
        if (window.FlowzaCart) { window.FlowzaCart.refresh(); window.FlowzaCart.open(); }
        else loadCart();
        setTimeout(function () { els.add.textContent = original; els.add.disabled = false; render(); }, 1800);
      })
      .catch(function () { els.add.textContent = original; els.add.disabled = false; });
  });

  var notify = $("[data-notify]");
  if (notify) notify.addEventListener("click", function () {
    var input = document.querySelector(".final input[type='email'], .signup input[type='email']");
    if (input) { input.scrollIntoView({ behavior: "smooth", block: "center" }); setTimeout(function () { input.focus(); }, 500); }
  });

  // Mobile sticky CTA: only float while the builder is on screen (slides away at the footer).
  var ctaEl = $("#bld-cta");
  if (ctaEl && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      ctaEl.classList.toggle("show", entries[0].isIntersecting);
    }, { rootMargin: "0px 0px -72px 0px", threshold: 0 }).observe(root);
  }

  render();
  // Then again once the bag is known. The drawer's own fz:cart:updated will
  // usually beat this; both paths are idempotent.
  loadCart();
})();
